import React from "react";
import {Box, FormControl, IconButton, MenuItem, Select} from "@mui/material";
import Sort from "@mui/icons-material/Sort";

type SortBoxProps = {
    onChangeDirection: (direction: "asc" | "desc") => void;
    onSelectField: (field: string) => void;
    sortDirection: "asc" | "desc";
    sortField: string;
    fields: Record<string, string>
}

export default ({onChangeDirection, onSelectField, sortDirection, sortField, fields}: SortBoxProps) => {


    return <Box display="flex">
        <IconButton
            sx={{marginTop: "auto"}}
            onClick={() => onChangeDirection(sortDirection === "asc" ? "desc" : "asc")}>
            {sortDirection === "asc" ? <Sort sx={{transform: "scaleY(-1)"}}/> : <Sort/>}
        </IconButton>
        <FormControl>
            <Select
                variant="standard"
                value={sortField}
                label={"Sort"}
                sx={{margin: "16px 8px 0"}}
                onChange={(e) => onSelectField(e.target.value)}>
                {Object.entries(fields).map(([k, v]) => <MenuItem key={k} value={k}>{v}</MenuItem>)}
            </Select>
        </FormControl>
    </Box>
}
